import React, { useEffect } from "react";
import { HeaderImgSection } from '../../Header/HeaderImgSection'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import slider from '../../../images/WEB HOSTING SERVICE/WEB-HOSTING-SERVICE--1900-220.png'
import sidebar from '../../../images/WEB HOSTING SERVICE/Web-Hosting-service.png'

function WebHostingServices() {
  useEffect(() => {
    document.title = "Web Hosting Services || OZVASERVICE"
 }, []);
  return (
    <>
      <HeaderImgSection img={slider} hTitle={'Services'} title={"Web Hosting Services"}></HeaderImgSection>
      <Container className='my-5'>
        <h1 className='text-center text-primary fw-semibold '>Web Hosting Services</h1>
        <p className='text-center'>OZVA SERVICE is your trusted partner for secure, reliable, and high-performance web hosting solutions. In today’s digital landscape, a robust hosting infrastructure is essential for building a strong, stable, and successful online presence.</p>


        <Row className='my-5 align-items-center'>
          <Col lg={6} className='mb-lg-0 mb-3'>
            <h2 className='text-dark fw-semibold'>Reliable Hosting Solutions Tailored to Your Needs</h2>
            <p>At OZVA SERVICE, we understand the importance of dependable and secure web hosting. That’s why we offer a comprehensive range of affordable, scalable, and high-performance hosting services — designed to meet the needs of businesses of all sizes, from startups to large enterprises.</p>
            <p>Whether you're launching a new website or migrating an existing one, we deliver tailored solutions including shared hosting, VPS hosting, cloud servers, and dedicated servers. Our goal is to provide hosting environments that offer fast loading times, maximum uptime, and seamless user experiences.</p>
            <h2 className='fw-bold my-4'>Why Choose OZVA SERVICE for Web Hosting?</h2>
            <p>What sets OZVA SERVICE apart is our unwavering commitment to security, performance, and client support. We implement advanced security protocols, enterprise-grade firewalls, daily backups, and malware scanning to ensure your data is always safe from cyber threats.</p>
            <p>To further support your operations, we offer 24/7 technical assistance. Our expert team is readily available to address any issues and help you manage your hosting infrastructure with confidence. Additionally, our user-friendly control panel enables you to easily manage, monitor, and update your hosting environment.</p>

          </Col>
          <Col lg={6} className='d-flex justify-content-center align-items-center'>
            <div className="">
              <img src={sidebar} className='img-fluid rounded-2' alt="" />
            </div>
          </Col>
        </Row>

        <h2 className='fw-bold mb-4'>What Can We Do for You?</h2>
        <ul>
          <li>In addition to hosting, we offer web design, web development, and digital marketing services — giving you a full-spectrum digital solution.</li>
          <li>Whether you're building a blog, e-commerce store, or business website, we provide the infrastructure to power your success.</li>
          <li>Our service goes beyond uptime — we deliver peace of mind with reliable performance, proactive monitoring, and expert-level support.</li>
        </ul>

      </Container>
    </>
  )
}

export default WebHostingServices
